import CountertopsIcon from "@mui/icons-material/Countertops"
import EquipmentCreate from "./create"
import EquipmentEdit from "./edit"
import EquipmentList from "./list"
import EquipmentShow from "./show"
import EquipmenDriverList from "./list.driver"
import EquipmenDriverParamList from "./list.driver.param"
import EquipmentAuditHistoryPage from "./audit"

const options = {
    list: EquipmentList,
    create: EquipmentCreate,
    edit: EquipmentEdit,
    show: EquipmentShow,
    listdrivers: EquipmenDriverList,
    listdriverparams: EquipmenDriverParamList,
    icon: CountertopsIcon,
    audit: EquipmentAuditHistoryPage,
    //recordRepresentation: (record: any)=> `${record.name} (${record.role})`,
}

export default options
